module.exports = __webpack_public_path__ + "assets/img/34_889_big.00ddf64a.jpg";